import React, { useState } from 'react';
import { Form, Input, Select, Button, Row, Col, Space, Card } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import type { CustomerSearchCriteriaDTO } from '@/shared/api/model';

const { Option } = Select;

interface CustomerSearchFormProps {
  onSearch: (criteria: CustomerSearchCriteriaDTO) => void;
  loading?: boolean;
}

const CustomerSearchForm: React.FC<CustomerSearchFormProps> = ({ onSearch, loading }) => {
  const [form] = Form.useForm();
  const [searchMode, setSearchMode] = useState<'quick' | 'advanced'>('quick');

  const handleSearch = (values: any) => {
    const { quickSearch, customerType, ...rest } = values;
    const criteria: CustomerSearchCriteriaDTO = {
      ...rest,
      searchTerm: quickSearch,
      custType: customerType,
      page: 0,
      size: 20,
    };
    onSearch(criteria);
  };

  const handleReset = () => {
    form.resetFields();
    onSearch({ page: 0, size: 20 });
  };

  return (
    <Card title="Search Customers">
      <Form form={form} onFinish={handleSearch} layout="vertical">
        <Space direction="vertical" style={{ width: '100%' }} size="middle">
          <div>
            <Button.Group>
              <Button
                type={searchMode === 'quick' ? 'primary' : 'default'}
                onClick={() => setSearchMode('quick')}
              >
                Quick Search
              </Button>
              <Button
                type={searchMode === 'advanced' ? 'primary' : 'default'}
                onClick={() => setSearchMode('advanced')}
              >
                Advanced Search
              </Button>
            </Button.Group>
          </div>

          {searchMode === 'quick' ? (
            <Row gutter={16}>
              <Col span={18}>
                <Form.Item name="quickSearch" label="Search by Name, Phone, or ID Card">
                  <Input
                    placeholder="Enter customer name, phone number, or ID card"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label=" ">
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SearchOutlined />}
                      loading={loading}
                      size="large"
                    >
                      Search
                    </Button>
                    <Button onClick={handleReset} icon={<ClearOutlined />} size="large">
                      Clear
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
          ) : (
            <>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="name" label="Customer Name">
                    <Input placeholder="Enter customer name" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="phone" label="Phone Number">
                    <Input placeholder="Enter phone number" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="idCard" label="ID Card Number">
                    <Input placeholder="Enter ID card number" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="custNo" label="Customer Number">
                    <Input placeholder="Enter customer number" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="branch" label="Branch">
                    <Input placeholder="Enter branch code" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="customerType" label="Customer Type">
                    <Select placeholder="Select customer type"  mode="multiple" allowClear>
                      <Option value="IND">Individual</Option>
                      <Option value="GRP">Group</Option>
                      <Option value="MEM">Member</Option>
                      <Option value="BUS">Business</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SearchOutlined />}
                      loading={loading}
                    >
                      Search
                    </Button>
                    <Button onClick={handleReset} icon={<ClearOutlined />}>
                      Clear
                    </Button>
                  </Space>
                </Col>
              </Row>
            </>
          )}
        </Space>
      </Form>
    </Card>
  );
};

export default CustomerSearchForm;
